import { Observable } from 'rxjs/Observable';
import { Iemail } from './iemail';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  private _communication: string = `/api/Communication/EnvoiEmailContactDossier/`;
  constructor(
    private _http: HttpClient
  ) { }

  public envoieEmailContactDossier(email: Iemail): Observable<Iemail>{

    return this._http.post<Iemail>(this._communication, email);
  }
}
